import React from 'react';

import { Helmet } from 'react-helmet';

import Intro from './components/Intro';
import Header from './components/Header';
import Landing from './components/Landing';
import Footer from './components/Footer';

import "./App.css"
import './css/style.css';

function App() {
  return (
    <div>
      <Helmet>
        <script src=
          "/init.js"
          type="text/javascript" />
      </Helmet>
      < Intro />
      < Header />
      < Landing />
      < Footer />
    </div>
  );
}

export default App;




